import React from 'react'
import { Tag } from './styles'

const PriceFairnessTag = ({ priceFairness, className }) => {
  return priceFairness ? (
    <Tag priceFairness={priceFairness} className={className}>
      {priceFairness}
    </Tag>
  ) : null
}

PriceFairnessTag.displayName = 'PriceFairnessTag'
export default PriceFairnessTag
